export var TabVariant;
(function (TabVariant) {
    TabVariant["brand"] = "brand";
    TabVariant["gray"] = "gray";
    TabVariant["underline"] = "underline";
    TabVariant["white"] = "white";
    TabVariant["minimal"] = "minimal";
    TabVariant["whiteTabFlat"] = "whiteTabFlat";
})(TabVariant || (TabVariant = {}));
export var Direction;
(function (Direction) {
    Direction["vertical"] = "vertical";
    Direction["horizontal"] = "horizontal";
})(Direction || (Direction = {}));
export var TabSize;
(function (TabSize) {
    TabSize["s"] = "s";
    TabSize["m"] = "m";
})(TabSize || (TabSize = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["trigger"] = "trigger";
    TriggerType["group"] = "group";
})(TriggerType || (TriggerType = {}));
